export const USER_STATUS_STYLES = {
  Activo: { bgcolor: "success.light", color: "success.dark" },
  Inactivo: { bgcolor: "grey.200", color: "text.secondary" },
  "Dado de baja": { bgcolor: "error.light", color: "error.dark" },
  Suspendido: { bgcolor: "grey.200", color: "text.secondary" },
  Prueba: { bgcolor: "info.light", color: "info.dark" },
  Vencido: { bgcolor: "error.light", color: "error.dark" },
};

export const getAccountStatusLabel = (active) =>
  active === false ? "Dado de baja" : "Activo";

export const USERS_TABLE_HEADERS = [
  "Empresa",
  "Plan",
  "Estado",
  "Vencimiento",
  "Último pago",
  "",
];
